import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {CommunicationUtilisateurDto} from './model/CommunicationUtilisateurDto';
import {map} from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class CommunicationUtilisateurService {

	private url = '/ws/communications-utilisateurs';

	constructor(private http: HttpClient) {
	}

	/**
	 * Récupère la communication utilisateur.
	 */
	recupererCommunicationUtilisateur(): Observable<CommunicationUtilisateurDto> {
		return this.http.get<CommunicationUtilisateurDto>(this.url)
				.pipe(map(communication => communication ? new CommunicationUtilisateurDto().deserialize(communication) : communication));
	}

	/**
	 * Enregistre et diffuse la communication à l'utilisateur. On fait un écart avec la norme REST en ajoutant le verbe dans l'url.
	 * C'est pour permettre d'appeler uniquement ce endpoint depuis d'autres applications sans authentification, sans impacter les autres endpoints présents dans cette classe.
	 *
	 * @param communicationUtilisateurDto – Le message d'information.
	 */
	diffuserMessages(communicationUtilisateurDto: CommunicationUtilisateurDto): Observable<void> {
		return this.http.post<void>(this.url + '/enregistrer-diffuser', communicationUtilisateurDto);
	}

	/**
	 * Permet de traduire le message de la langue source vers les langues cibles.
	 *
	 * @param codeLangueSource – Le code de la langue source.
	 * @param codesLanguesCibles – Les codes des langues cibles.
	 * @param message – Le message à traduire.
	 */
	traduireVersLanguesDestinations(codeLangueSource: string, codesLanguesCibles: string[], message: string): Observable<CommunicationUtilisateurDto> {
		const params = new HttpParams()
				.set('codeLangueSource', codeLangueSource)
				.set('codesLanguesCibles', codesLanguesCibles.join(','))
				.set('message', message);
		return this.http.get<CommunicationUtilisateurDto>(this.url + '/traduire-message', {params: params})
				.pipe(map(communication => new CommunicationUtilisateurDto().deserialize(communication)));
	}
}
